var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4095 0.227827C11.7462 -0.0759423 12.2538 -0.0759423 12.5905 0.227827L16.5905 3.83567C16.9575 4.16662 16.9905 4.73672 16.6644 5.10903C16.3382 5.48135 15.7764 5.51488 15.4095 5.18394L12.8889 2.91049V14.8824C12.8889 15.3805 12.4909 15.7843 12 15.7843C11.5091 15.7843 11.1111 15.3805 11.1111 14.8824V2.91049L8.59055 5.18394C8.22363 5.51488 7.66179 5.48135 7.33564 5.10903C7.00949 4.73672 7.04254 4.16662 7.40945 3.83567L11.4095 0.227827ZM14.6669 7.64741C14.6774 7.14938 15.0837 6.75427 15.5745 6.76491L17.3903 6.80426C18.8405 6.83569 20 8.03762 20 9.50953V20.2941C20 21.7885 18.8061 23 17.3333 23H6.66667C5.19391 23 4 21.7885 4 20.2941V9.47059C4 7.97617 5.19391 6.76471 6.66667 6.76471H8.44444C8.93536 6.76471 9.33333 7.16853 9.33333 7.66667C9.33333 8.16481 8.93536 8.56863 8.44444 8.56863H6.66667C6.17575 8.56863 5.77778 8.97245 5.77778 9.47059V20.2941C5.77778 20.7923 6.17575 21.1961 6.66667 21.1961H17.3333C17.8243 21.1961 18.2222 20.7923 18.2222 20.2941V9.50953C18.2222 9.01889 17.8357 8.61825 17.3523 8.60777L15.5366 8.56842C15.0458 8.55778 14.6564 8.14543 14.6669 7.64741Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.60f1f2bdc300adb5fbc3fe9e9626ad1b.svg";
export { ForwardRef as ReactComponent };